import React from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { PROVINCE } from "../../constants";

export default function PersonalDataStep({
  formData,
  errors,
  handleInputChange,
  handleContinua,
  onReset,
}) {
  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" mb={4}>
        <HomeRoundedIcon color="primary" fontSize="large" />
        <Typography variant="h5" fontWeight={700}>
          I Tuoi Dati
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Nome"
            placeholder="Il tuo nome"
            value={formData.nome}
            onChange={handleInputChange("nome")}
            variant="outlined"
            required
            error={errors.nome}
            helperText={errors.nome ? "Inserisci Nome" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Cognome"
            placeholder="Il tuo cognome"
            value={formData.cognome}
            onChange={handleInputChange("cognome")}
            variant="outlined"
            required
            error={errors.cognome}
            helperText={errors.cognome ? "Inserisci Cognome" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email"
            placeholder="la.tua@email.com"
            type="email"
            value={formData.email}
            onChange={handleInputChange("email")}
            variant="outlined"
            required
            error={errors.email}
            helperText={errors.email ? "Inserisci Email" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Telefono"
            placeholder="+39 123 456 7890"
            value={formData.telefono}
            onChange={handleInputChange("telefono")}
            variant="outlined"
            required
            error={errors.telefono}
            helperText={errors.telefono ? "Inserisci Telefono" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Provincia</InputLabel>
            <Select
              value={formData.provincia}
              label="Provincia"
              onChange={handleInputChange("provincia")}
            >
              <MenuItem value="">
                <em>Seleziona provincia</em>
              </MenuItem>
              {PROVINCE.map((provincia) => (
                <MenuItem key={provincia.value} value={provincia.value}>
                  {provincia.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Indirizzo"
            placeholder="Via Roma 123"
            value={formData.indirizzo}
            onChange={handleInputChange("indirizzo")}
            variant="outlined"
          />
        </Grid>
      </Grid>

      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={2}
        mt={4}
      >
        <Button
          variant="outlined"
          onClick={onReset}
          size="large"
        >
          Reset Campi
        </Button>
        <Button
          variant="contained"
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={handleContinua}
          size="large"
        >
          Continua
        </Button>
      </Stack>
    </Box>
  );
}
